import client from '@lib/http/client'

import { LeadField } from './types'

export const editLead = ({
  uuid,
  fields,
  sourceUuid,
  sourceType
}: {
  uuid: string
  fields: LeadField[]
  sourceUuid: string
  sourceType: string
}) => client.post(`/leads/${uuid}/edit`, { fields, sourceUuid, sourceType })
